export const awsBasePath = process.env.GATSBY_AWS_ENDPOINT
export const graphql2Endpoint = process.env.GATSBY_GRAPHQL2_ENDPOINT
export const priceCurrency = process.env.GATSBY_PUBLISHING_CURRENCY || null
